/* eslint-disable max-lines */
import { PageId } from './pages'

export const LIVE_CHAT_PUBLIC_KEY = '10826272'
export const FREE_USER_GROUP_ID = '69'
export const PAID_USER_GROUP_ID = '23'

export const enum CurrentEnvironment {
  DEV = 'dev',
  STAGE = 'stage',
  PROD = 'prod',
}

export const enum RequestMethod {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE',
  HEAD = 'HEAD',
  OPTIONS = 'OPTIONS',
  PATCH = 'PATCH',
}

export const enum MediaBreakpoint {
  MIN_PHONE = 321,
  SMALL_PHONE = 360,
  MEDIUM_PHONE = 375,
  MAX_PHONE = 415,
  TABLET = 520,
}

export const enum CardPaymentFieldName {
  NAME = 'name',
  NUMBER = 'cardNumber',
  EXPIRY = 'cardExpiry',
  CVC = 'cardCvc',
}

export const CURRENCY_TO_ICON = {
  USD: '$',
  EUR: '€',
  GBP: '£',
  JPY: '¥',
  MXN: '$',
  CAD: '$',
  AUD: '$',
}

export const SUPPORT_FORM_LINKS_MAP = {
  [CurrentEnvironment.PROD]: 'https://account.luvly.care/contact-form',
  [CurrentEnvironment.STAGE]: 'https://account-luvly.gistage.com/contact-form',
  [CurrentEnvironment.DEV]: 'https://account-luvly.gidev.xyz/contact-form',
}
export const TERMS_OF_USE_LINK = 'https://luvly.care/terms-of-use'
export const PRIVACY_POLICY_LINK = 'https://luvly.care/privacy-policy'
export const CDN_FOLDER_LINK =
  'https://cdn-prod-unified-content.gismart.xyz/34486912bbc40fd28752c59e42098ae09101436d76566d91d767d95811286b02'

export const EMAIL_REGEXP =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3})|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
export const EMAIL_FROM_URL_REGEXP = /email=([^&]*)/
export const EMAIL_DOMAIN_REGEXP = /@(.*)/
export const EMAIL_USERNAME_REGEXP = /(.*)@/

export const enum LoginMethod {
  EMAIL = 'email',
}

export const enum LoginMethodRaw {
  EMAIL = 'password',
}

export const LOGIN_METHOD_RAW_MAP = {
  [LoginMethodRaw.EMAIL]: LoginMethod.EMAIL,
}

export const EMAIL_LOGIN_INSTRUCTION_LINK =
  'https://facetory.onelink.me/qTZZ?pid=web2web_payment_success&deep_link_value=custom_token&c=Facetory_DL_Password&af_dp=gismartfacetory%3A%2F%2F&deep_link_sub1=gismartfacetory%3A%2F%2F%3Flogin%3Dpassword'

export const enum FirebaseSignUpErrorCode {
  EMAIL_EXISTS = 'auth/email-already-in-use',
}

export const enum FirebaseSignInErrorCode {
  WRONG_PASSWORD = 'auth/wrong-password',
  USER_NOT_FOUND = 'auth/user-not-found',
  USER_DISABLED = 'auth/user-disabled',
  INVALID_EMAIL = 'auth/invalid-email',
}

export const enum Color {
  CORAL = '#ff7262',
  PRIMARY = '#ff8276',
  ERROR = '#ea5873',
  ERROR_SECONDARY = '#e74c3c',
  WHITE = '#fff',
  SANDY = '#fbf8f3',
  DARK = '#2d3240',
  DARK_SECONDARY = '#2c3131',
  LIGHT = '#81848c',
  BLUE_DARK = '#17202a',
  BLUE_GRAY = '#4C4C4C',
  MIDNIGHT_BLUE = '#292d3d',
  GRAY = '#626262',
  CORAL_GRAY = '#f2f3f5',
  GRAY_SECONDARY = '#aaacb2',
  GRAY_LIGHT = '#e9e9e9',
  SILVER_GRAY = '#dadadd',
  RED = '#e85e47',
  LIGHT_PINK = '#febfba',
  LIGHT_PURPLE = '#c5d1ff',
  DEFAULT_BACKGROUND = '#fdfdff',
  CREAMY = '#fae0d5',
  LIGHT_SANDY = '#f6f5f4',
  ASH_GRAY = '#c4c4c4',
}

export const enum TimeInterval {
  DAY = 'day',
  WEEK = 'week',
  MONTH = 'month',
  YEAR = 'year',
}

export const enum EventLoggerInstanceName {
  GIA = 'gia-amplitude',
  AMPLITUDE = 'amplitude',
  USER_FLOW_TRACKER = 'user-flow-tracker',
}

export const enum PlatformOS {
  ANDROID = 'Android',
  IOS = 'iOS',
  MAC_OS = 'MacOs',
  UNKNOWN = 'unknown',
}

export const enum AppWithInAppBrowser {
  FACEBOOK = 'facebook',
  INSTAGRAM = 'instagram',
}

export const enum UserAgent {
  INSTAGRAM = 'instagram',
  FACEBOOK = 'facebook',
  OTHER = 'other',
}

export const enum Cohort {
  QUIZ_2 = 'quiz_2',
  LUVLY_EMAIL_7 = 'luvly_email_7',
  LUVLY_INTRO_FAST = 'luvly_intro_fast',
  LUVLY_CHAT_UPGRADE_12_PDF = 'luvly_chat_upgrade12_pdf',
  LUVLY_CHAT_UPGRADE_12_EX_PDF = 'luvly_chat_upgrade12ex_pdf',
  LUVLY_CHAT_UPGRADE_BUNDLE_PDF = 'luvly_chat_upgrade_bundle_pdf',
  LUVLY_EMAIL_8 = 'luvly_email_8',
  LUVLY_EMAIL_SALE = 'luvly_email_sale',
  LUVLY_EMAIL_INTRO_FAST = 'luvly_email_intro_fast',
  LUVLY_EMAIL_COACHING = 'luvly_email_coaching',
  LUVLY_CANCEL_INTRO_FAST = 'luvly_cancel_intro_fast',
  LUVLY_COSMETIC_SCANNER = 'luvly_cosmetic_scanner',
  LUVLY_CHAT = 'luvly_chat',
  LUVLY_INTRO_SALE = 'luvly_intro_sale',
  LUVLY_INTRO4_SALE = 'luvly_intro4_sale',
  LUVLY_REF = 'luvly_ref',
  LUVLY_REF4 = 'luvly_ref4',
  LUVLY_REF03 = 'luvly_ref03',
  LUVLY_PRINTABLE = 'luvly_printable',
  LUVLY_PRINTABLE_4 = 'luvly_printable4',
  LUVLY_PRINTABLE_03 = 'luvly_printable03',
  LUVLY_CANCEL_INTRO_1 = 'luvly_cancel_intro_1',
  LUVLY_CHIN = 'luvly_chin',
  LUVLY_INFLUENCERS = 'luvly_influencers',
  LUVLY_GIFT = 'luvly_mobile_cohort',
  LUVLY_WELLHUB = 'luvly_wellhub',
  LUVLY_AREF = 'luvly_aref',
  LUVLY_REF4_TT = 'luvly_ref4_tt',
}

export const enum ChildCohort {
  LUVLY_REF_GROWTH = 'luvly_ref_growth',
}

export const LUVLY_REF6_CHILD_COHORT = 'luvly_ref6'

export const INTRO_EMAIL_COHORTS: Cohort[] = [
  Cohort.LUVLY_EMAIL_INTRO_FAST,
  Cohort.LUVLY_CANCEL_INTRO_FAST,
]

export const enum PagePath {
  LOCALHOST = 'localhost',
}

export const enum Gender {
  MALE = 'male',
  FEMALE = 'female',
  NON_BINARY = 'other',
}

export const enum UserGoal {
  WRINKLE_FREE_SKIN = 'get_rid_of_wrinkles',
  REDUCE_FACE_FAT = 'reduce_face_fat',
  BOTH_OPTIONS = 'both_options',
  TIGHTEN_SKIN = 'tighten_skin',
}

export const enum UserAge {
  TWENTY = '20', // 18-29
  THIRTY = '30', // 30-39
  FOURTY = '40', // 40-49
  FIFTY = '50', // 50-59
  SIXTY = '60', // 60-69
  SEVENTY = '70', // 70+
}

export const enum SubscriptionListType {
  PURCHASE = 'purchase',
  UPGRADE = 'upgrade',
  UPSELL = 'upsell',
  ONE_TIME = 'one_time',
  SECONDARY = 'secondary',
  GIFT = 'gift',
}

export const enum SubscriptionTagsType {
  TAX = 'tax',
  NO_TAX = 'no_tax',
  CANCEL_OFFER = 'cancel',
  USD = 'us',
  WORLDWIDE = 'ww',
  WELLNESS_BUNDLE = 'bundle',
  WELLNESS_BUNDLE_CANCEL = 'cancel_bundle',
  HAIR_GUIDE = 'hair_guide',
  COACHING = 'luvly_coaching',
  HIGHER_PRICES = 'higher_prices',
  HIGH_PRICES_LUVLY_REF = 'ref_high',
  HIGHER_INTRO_REF4 = 'higher_intro_ref4',
  THREE_MONTHS_SOLDOUT = '3_soldout',
  COURSES = 'courses',
  REF03_B = '82_b',
  NEW_PRICES_REF_B = '81_b',
  NEW_PRICES_REF_C = '81_c',
  REF6_NEW_PRICE = '80_b',
  ARABIC = 'ar',
  JAPANESE = 'ja',
  INTRO4_SALE_HIGH_JA = '92_b',
}

export const enum OptionType {
  RADIO = 'radio',
  CHECKBOX = 'checkbox',
}

export const enum UserAnswer {
  YES = 'yes',
  NO = 'no',
}

export const enum Country {
  USA = 'US',
  CANADA = 'CA',
  AUSTRALIA = 'AU',
  MEXICO = 'MX',
}

export const enum LiveChatStatus {
  MAXIMIZED = 'maximized',
  MINIMIZED = 'minimized',
  HIDDEN = 'hidden',
}

export const enum Locale {
  IN_CONTEXT = 'af',
  ENGLISH = 'en',
  FRENCH = 'fr',
  SPANISH = 'es',
  ITALIAN = 'it',
  PORTUGUESE = 'pt',
  JAPANESE = 'ja',
  GERMAN = 'de',
  POLISH = 'pl',
  ARABIC = 'ar',
}

export const APP_NAME = 'facetory'
export const CENTS_IN_DOLLAR = 100
export const INITIAL_PRICE = 0
export const DATES_NUMBER_FOR_ANIMATION = 8
export const PAGE_TRANSITION_DELAY = 500
export const CHAT_PAGE_TRANSITION_DELAY = 1500
export const ONBOARDING_INPUT_MIN_LENGTH = 5
export const CUSTOM_TOKEN_LOCAL_STORAGE_KEY = 'custom_token'
export const DEFAULT_CURRENCY = 'usd'
export const TEST_ENV_QUERY_PARAM = 'is_test_environment'
export const SNAPCHAT_QUERY_PARAM = 'is_snapchat_payment'
export const LANG_QUERY_PARAM = 'lang'
export const KEYWORD_PARAM = 'lp_dynamic'
export const COHORT_QUERY_PARAM = 'cohort'
export const UUID_QUERY_PARAM = 'uuid'
export const EMAIL_QUERY_PARAM = 'email'
export const INITIAL_LANGUAGE = 'en'
export const NO_GROWTH_BOOK_TEST = 'no_test'
export const EXPERIMENT_ID_NOT_SET = 'experiment_id_not_set'
export const MAX_VISIBLE_PROBLEM_AREAS_NUMBER = 2
export const PROGRESS_SECTION_STEP = 1

export const USER_GOALS_GRAPH: Record<UserGoal, string> = {
  [UserGoal.WRINKLE_FREE_SKIN]: 'commonComponents.wrinkleFreeSkin',
  [UserGoal.REDUCE_FACE_FAT]: 'commonComponents.slimFace',
  [UserGoal.BOTH_OPTIONS]: 'commonComponents.idealSkin',
  [UserGoal.TIGHTEN_SKIN]: 'commonComponents.idealSkin',
}

export const USER_GOALS_TITLE: Record<UserGoal, string> = {
  [UserGoal.WRINKLE_FREE_SKIN]: 'commonComponents.wrinkleFreeSkin',
  [UserGoal.REDUCE_FACE_FAT]: 'commonComponents.slimFace',
  [UserGoal.BOTH_OPTIONS]: 'commonComponents.perfectSkin',
  [UserGoal.TIGHTEN_SKIN]: 'commonComponents.perfectSkin',
}

export const DAYS_NUMBER = {
  [PageId.SHORT_PROGRAM_DESCRIPTION]: 30,
  [PageId.SHORT_PROGRAM_DESCRIPTION_SECOND]: 23,
  [PageId.PURCHASE_EMAIL]: 16,
  [PageId.PURCHASE]: 16,
}

export const enum SubscriptionStatus {
  ACTIVE = 'active',
  TRIAL = 'trial',
  CANCELLED = 'cancelled',
  NOT_ACTIVE = 'not_active',
}

export const GENDER_TRANSLATIONS_MAP = {
  [Gender.MALE]: 'commonComponents.males',
  [Gender.FEMALE]: 'commonComponents.females',
  [Gender.NON_BINARY]: 'commonComponents.people',
}

export const enum SubscriptionProduct {
  SEVEN_DAY = 7,
  ONE_MONTH = 30,
  THREE_MONTHS = 90,
  SIX_MONTHS = 180,
  TWO_MONTHS = 60,
  FOUR_MONTHS = 120,
  TWELVE_MONTHS = 365,
  THREE_YEARS = 1095,
}

export const enum BillingCycle {
  ONE_MONTH = 1,
  THREE_MONTHS = 3,
  SIX_MONTHS = 6,
}

export const SUBSCRIPTION_PERIOD_TO_DURATION_MAP = {
  [BillingCycle.ONE_MONTH]: SubscriptionProduct.ONE_MONTH,
  [BillingCycle.THREE_MONTHS]: SubscriptionProduct.THREE_MONTHS,
  [BillingCycle.SIX_MONTHS]: SubscriptionProduct.SIX_MONTHS,
}

export const WeeklyTo3Month = 'weekly_to_3_month'

export const enum ScreenName {
  LONG_START_AGE = 'long_start_age',
  PURCHASE = 'onboarding',
  EMAIL_OFFER = 'email_offer',
  CANCEL_OFFER = 'cancel_offer',
  CANCEL_OFFER_NY = 'cancel_offer_ny',
  CANCEL_OFFER_LONG = 'paywall_cancel_offer',
  UPSELL_1_PLAN = 'upsell_1_plan',
  UPSELL_3_PLANS = 'upsell_3_plans',
  UPSELL_CANCEL_OFFER = 'upsell_cancel_offer',
  UPSELL_DISCOUNT_PLAN = 'upsell_discount_plan',
  UPSELL_SWITCHER = 'upsell_switcher',
  UPSELL_COACHING = 'upsell_coaching',
  UPSELL_COACHING_CANCEL = 'upsell_coaching_cancel',
  LONG_PAYWALL = 'long_paywall',
  LIVECHAT_UPGRADE = 'livechat_upgrade',
  CHECKOUT = 'checkout',
  LIVECHAT_WELLNESS_BUNDLE = 'livechat_wellness_bundle',
  LIVECHAT_WELLNESS_BUNDLE_CANCEL_OFFER = 'livechat_wellness_bundle_cancel_offer',
  UPSELL_GIFT_CARD = 'upsell_gift_card',
  WELLHUB_LOGIN = 'wellhub_login',
}

export const enum UpsellProduct {
  MIX = 'doubleChinAndFaceLifting',
  CHIN_SHAPER = 'doubleChin',
  FACE_LIFTING = 'faceLifting',
  WELLNESS_APPS_BUNDLE = 'bundle',
  HAIR_GUIDE = 'hairCareUpsell',
  GIFT_CARD = 'giftCard',
  LYMPH_AND_POSTURE = 'LymphDrainageCourseAndPostureFitnessCourse',
  LYMPH_DRAINAGE = 'LymphDrainageCourse',
  POSTURE_FITNESS = 'PostureFitnessCourse',
}

export const UPSELL_PRODUCT_EVENT_NAMES_MAP = {
  [UpsellProduct.CHIN_SHAPER]: 'double_chin',
  [UpsellProduct.FACE_LIFTING]: 'face_lifting',
  [UpsellProduct.MIX]: 'double_chin_face_lifting',
  [UpsellProduct.WELLNESS_APPS_BUNDLE]: 'wellness_bundle',
  [UpsellProduct.HAIR_GUIDE]: 'hair_guide',
}

export const enum FaceScanSkipScreen {
  INFO_SCREEN = 'info_screen',
  MAIN_SCREEN = 'screen',
}

export const POST_PAYMENT_PAGES: string[] = [
  PageId.UPSELL_PAYWALL,
  PageId.COACHING_PAYWALL,
  PageId.COACHING_CANCEL_PAYWALL,
  PageId.FINISHING_TOUCHES,
  PageId.LOGIN,
  PageId.DOWNLOAD,
]

export const PAGES_WITHOUT_HEADER: string[] = [
  PageId.INTRO,
  PageId.INTRO_SALE_AGE,
  PageId.FACE_SCAN_PREVIEW,
  PageId.FACE_SCAN,
  PageId.FACE_SCAN_RESULTS,
  PageId.PURCHASE_UPGRADE,
  PageId.AGE_AS_INTRO,
  PageId.INTRO_PLAN,
  PageId.LIKE_CHAT_INTRO,
  PageId.INTRO_REFUND,
  PageId.INTRO_INFLUENCERS,
  PageId.INTRO_GIFT_CARD,
  PageId.LOADING_INTRO,
  PageId.LOADING_INTRO_2,
  PageId.LOADING_INTRO_3,
  PageId.WELLHUB_DOWNLOAD,
  PageId.SPECIAL_PURCHASE_CANCEL_OFFER,
  PageId.HOLIDAY_GIFT,
  PageId.AGE_AS_INTRO_WITH_IMAGES,
]

export const SUPPORTED_LOCALES_MAP: Record<Cohort, string[]> = {
  [Cohort.QUIZ_2]: [Locale.ENGLISH, Locale.FRENCH, Locale.SPANISH],
  [Cohort.LUVLY_EMAIL_7]: [Locale.ENGLISH, Locale.FRENCH, Locale.SPANISH],
  [Cohort.LUVLY_CHAT_UPGRADE_12_PDF]: [Locale.ENGLISH, Locale.FRENCH],
  [Cohort.LUVLY_CHAT_UPGRADE_12_EX_PDF]: [Locale.ENGLISH, Locale.FRENCH],
  [Cohort.LUVLY_CHAT_UPGRADE_BUNDLE_PDF]: [Locale.ENGLISH, Locale.FRENCH],
  [Cohort.LUVLY_COSMETIC_SCANNER]: [Locale.ENGLISH],
  [Cohort.LUVLY_CHAT]: [Locale.ENGLISH],
  [Cohort.LUVLY_CHIN]: [Locale.ENGLISH],
  [Cohort.LUVLY_INFLUENCERS]: [Locale.ENGLISH, Locale.SPANISH],
  [Cohort.LUVLY_GIFT]: [Locale.ENGLISH],
  [Cohort.LUVLY_INTRO_FAST]: [
    Locale.ENGLISH,
    Locale.FRENCH,
    Locale.SPANISH,
    Locale.ITALIAN,
    Locale.PORTUGUESE,
    Locale.JAPANESE,
    Locale.GERMAN,
    Locale.POLISH,
  ],
  [Cohort.LUVLY_EMAIL_8]: [
    Locale.ENGLISH,
    Locale.FRENCH,
    Locale.SPANISH,
    Locale.ITALIAN,
    Locale.PORTUGUESE,
    Locale.JAPANESE,
    Locale.GERMAN,
    Locale.POLISH,
  ],
  [Cohort.LUVLY_EMAIL_COACHING]: [Locale.ENGLISH],
  [Cohort.LUVLY_EMAIL_SALE]: [
    Locale.ENGLISH,
    Locale.FRENCH,
    Locale.SPANISH,
    Locale.ITALIAN,
    Locale.PORTUGUESE,
  ],
  [Cohort.LUVLY_EMAIL_INTRO_FAST]: [
    Locale.ENGLISH,
    Locale.FRENCH,
    Locale.SPANISH,
  ],
  [Cohort.LUVLY_CANCEL_INTRO_FAST]: [
    Locale.ENGLISH,
    Locale.FRENCH,
    Locale.SPANISH,
  ],
  [Cohort.LUVLY_INTRO_SALE]: [
    Locale.ENGLISH,
    Locale.FRENCH,
    Locale.SPANISH,
    Locale.ITALIAN,
    Locale.PORTUGUESE,
    Locale.JAPANESE,
    Locale.GERMAN,
    Locale.ARABIC,
  ],
  [Cohort.LUVLY_INTRO4_SALE]: [
    Locale.ENGLISH,
    Locale.FRENCH,
    Locale.SPANISH,
    Locale.ITALIAN,
    Locale.PORTUGUESE,
    Locale.JAPANESE,
    Locale.GERMAN,
    Locale.POLISH,
  ],
  [Cohort.LUVLY_REF]: [
    Locale.ENGLISH,
    Locale.FRENCH,
    Locale.SPANISH,
    Locale.ITALIAN,
    Locale.PORTUGUESE,
    Locale.GERMAN,
    Locale.JAPANESE,
    Locale.POLISH,
    Locale.ARABIC,
  ],
  [Cohort.LUVLY_REF03]: [
    Locale.ENGLISH,
    Locale.FRENCH,
    Locale.SPANISH,
    Locale.ITALIAN,
    Locale.PORTUGUESE,
    Locale.GERMAN,
    Locale.JAPANESE,
    Locale.POLISH,
    Locale.ARABIC,
  ],
  [Cohort.LUVLY_AREF]: [
    Locale.ENGLISH,
    Locale.SPANISH,
    Locale.ARABIC,
    Locale.JAPANESE,
  ],
  [Cohort.LUVLY_REF4]: [
    Locale.ENGLISH,
    Locale.FRENCH,
    Locale.SPANISH,
    Locale.ITALIAN,
    Locale.PORTUGUESE,
    Locale.GERMAN,
    Locale.JAPANESE,
    Locale.POLISH,
  ],
  [Cohort.LUVLY_REF4_TT]: [
    Locale.ENGLISH,
    Locale.FRENCH,
    Locale.SPANISH,
    Locale.ITALIAN,
    Locale.PORTUGUESE,
    Locale.GERMAN,
    Locale.JAPANESE,
    Locale.POLISH,
    Locale.ARABIC,
  ],
  [Cohort.LUVLY_PRINTABLE]: [
    Locale.ENGLISH,
    Locale.FRENCH,
    Locale.SPANISH,
    Locale.GERMAN,
    Locale.POLISH,
    Locale.ITALIAN,
    Locale.PORTUGUESE,
    Locale.JAPANESE,
  ],
  [Cohort.LUVLY_PRINTABLE_4]: [
    Locale.ENGLISH,
    Locale.FRENCH,
    Locale.SPANISH,
    Locale.GERMAN,
    Locale.POLISH,
    Locale.ITALIAN,
    Locale.PORTUGUESE,
    Locale.JAPANESE,
  ],
  [Cohort.LUVLY_PRINTABLE_03]: [
    Locale.ENGLISH,
    Locale.FRENCH,
    Locale.SPANISH,
    Locale.GERMAN,
    Locale.POLISH,
    Locale.ITALIAN,
    Locale.PORTUGUESE,
    Locale.JAPANESE,
  ],
  [Cohort.LUVLY_CANCEL_INTRO_1]: [
    Locale.ENGLISH,
    Locale.FRENCH,
    Locale.SPANISH,
  ],
  [Cohort.LUVLY_WELLHUB]: [Locale.ENGLISH, Locale.SPANISH],
}

export const SUPPORTED_LOCALES = [
  Locale.ENGLISH,
  Locale.SPANISH,
  Locale.FRENCH,
  Locale.ITALIAN,
  Locale.PORTUGUESE,
  Locale.JAPANESE,
  Locale.GERMAN,
  Locale.ARABIC,
]

export const EMAIL_DOMAINS = [
  'gmail.com',
  'hotmail.com',
  'yahoo.com',
  'outlook.com',
  'aol.com',
  'icloud.com',
  'live.com',
  'msn.com',
  'me.com',
  'mac.com',
  'googlemail.com',
  'facebook.com',
  'verizon.net',
  'rediffmail.com',
  'zohomail.com',
  'zoho.com',
  'mail.com',
  'google.com',
  'comcast.com',
  'hotmail.co.uk',
  'yahoo.co.uk',
  'att.net',
  'gmz.com',
]

export const enum CameraAccess {
  ALLOW = 'allow',
  DENY = 'deny',
}

export const ML_NO_PROBLEM_AREAS = 'not_found'

export const ML_DEFAULT_PROBLEM_AREAS = ['wrinkles']
export const DEFAULT_USER_AGE = UserAge.TWENTY

export const LIVECHAT_UPGRADE_COHORTS: Cohort[] = [
  Cohort.LUVLY_CHAT_UPGRADE_12_PDF,
  Cohort.LUVLY_CHAT_UPGRADE_12_EX_PDF,
  Cohort.LUVLY_CHAT_UPGRADE_BUNDLE_PDF,
]

export const OPEN_SANS_COHORTS: Cohort[] = [
  Cohort.LUVLY_CHIN,
  Cohort.LUVLY_GIFT,
  Cohort.LUVLY_WELLHUB,
]

export const TRIAL_SUBSCRIPTION_AVAILABLE_COHORTS: Cohort[] = [
  Cohort.LUVLY_INTRO_FAST,
  Cohort.LUVLY_COSMETIC_SCANNER,
  Cohort.LUVLY_INTRO_SALE,
  Cohort.LUVLY_REF,
  Cohort.LUVLY_REF03,
  Cohort.LUVLY_REF4,
  Cohort.LUVLY_REF4_TT,
  Cohort.LUVLY_PRINTABLE,
  Cohort.LUVLY_CHIN,
  Cohort.LUVLY_AREF,
]

export const enum PlanAddition {
  BONUS = 'Bonus',
  PRINTABLE_PDF = 'Printable',
}

export const SEVEN_DAY_TRIAL_DURATION = '7'

export const MAX_SUBSCRIPTION_DURATION_YEARS = 3

export const MINIMUM_COUNT_OF_MONTH = 1

export const FREE_BONUS_FOR_UPGRADE = '0.00'

export const VAT_INCLUDED_COUNTRY = ['US', 'CA', 'AU']

export const I18N_CONTEXT_COHORT_MAP: Partial<Record<Cohort, string>> = {
  [Cohort.LUVLY_INTRO_FAST]: 'intro_fast',
  [Cohort.LUVLY_COSMETIC_SCANNER]: 'cosmetic',
  [Cohort.LUVLY_CHAT]: 'chat',
  [Cohort.LUVLY_REF]: 'refund',
  [Cohort.LUVLY_REF03]: 'refund',
  [Cohort.LUVLY_REF4]: 'refund',
  [Cohort.LUVLY_PRINTABLE]: 'printable',
  [Cohort.LUVLY_CHIN]: 'chin',
  [Cohort.LUVLY_WELLHUB]: 'wellhub',
  [Cohort.LUVLY_AREF]: 'aref',
}

export const PROGRESS_STEPS_LENGTH_MAP: Partial<Record<Cohort, number>> = {
  [Cohort.LUVLY_CHAT]: 30,
  [Cohort.LUVLY_CHIN]: 31,
  [Cohort.LUVLY_GIFT]: 3,
  [Cohort.LUVLY_INTRO_FAST]: 37,
  [Cohort.LUVLY_WELLHUB]: 11,
}

export const EU_COUNTRY_CODES = [
  'AT',
  'BE',
  'BG',
  'HR',
  'CY',
  'CZ',
  'DK',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'HU',
  'IE',
  'IT',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SK',
  'SI',
  'ES',
  'SE',
  'GB',
]

export const USA_STATES_WITH_COOKIES = [
  'CA',
  'CT',
  'CO',
  'VA',
  'NV',
  'UT',
  'AZ',
  'DE',
  'IA',
  'IL',
  'FL',
  'ME',
  'MD',
  'MN',
  'MT',
  'NE',
  'NY',
  'OR',
  'SC',
  'TX',
]

export const LANGUAGE_WITH_COOKIES = [Locale.ENGLISH, Locale.GERMAN]

export const PAYPAL_FREE_COUNTRY_CODES = [
  'AR',
  'CO',
  'PE',
  'CL',
  'DO',
  'UY',
  'EC',
  'GT',
  'VE',
  'PY',
  'BO',
  'NI',
  'HN',
  'CR',
  'PA',
  'SV',
  'BR',
  'IN',
  'ZA',
  'EG',
  'KE',
  'NG',
  'MA',
  'DZ',
  'UG',
  'TZ',
  'SN',
  'CM',
  'GH',
  'CI',
  'MG',
  'MW',
  'MZ',
  'ZW',
  'BJ',
  'RW',
  'NE',
  'ML',
  'BF',
  'AO',
  'SS',
  'SD',
  'GA',
  'LR',
  'CD',
  'GN',
  'ET',
  'BI',
  'KW',
  'EH',
  'SO',
  'SL',
  'NA',
  'DJ',
  'LY',
  'TD',
  'CV',
  'ST',
  'ZM',
  'CG',
  'TG',
  'SZ',
  'SC',
  'PH',
]

export const enum CookieConsentOption {
  STRICTLY_NECESSARY = 'necessary',
  ANALYTICS_AND_PERFORMANCE = 'analytics',
  ADVERTIZING_AND_TARGETING = 'advertising',
  FUNCTIONAL_COOKIES = 'functional_cookies',
  REJECT_ALL = 'reject_all',
}

export const enum GAConsent {
  GRANTED = 'granted',
  DENIED = 'denied',
}

export const enum FBConsent {
  REVOKE = 'revoke',
  GRANT = 'grant',
}

export const enum WellnessBundleApp {
  NUTRIMATE = 'NutriMate',
  DANCEBIT = 'Dancebit',
  FITME = 'FitMe',
}

export const enum HotJarClientId {
  PROD = '4966693',
  DEV = '3925319',
}

export const HOTJAR_AVAILABLE_COHORTS: Cohort[] = [
  Cohort.LUVLY_INTRO_FAST,
  Cohort.LUVLY_CHAT,
  Cohort.LUVLY_REF,
  Cohort.LUVLY_REF03,
  Cohort.LUVLY_REF4,
  Cohort.LUVLY_CHIN,
  Cohort.LUVLY_WELLHUB,
]

export const enum DynamicDiscountTheme {
  VIOLET = 'violet',
  CORAL = 'coral',
  BLUE = 'blue',
  BLACK = 'black',
}

export const DYNAMIC_DISCOUNT_COHORTS = [
  Cohort.LUVLY_INTRO_SALE,
  Cohort.LUVLY_INTRO4_SALE,
  Cohort.LUVLY_EMAIL_SALE,
  Cohort.LUVLY_CHIN,
  Cohort.LUVLY_PRINTABLE,
  Cohort.LUVLY_PRINTABLE_4,
  Cohort.LUVLY_PRINTABLE_03,
  Cohort.LUVLY_AREF,
]

export const PINNED_PROGRESS_BAR_WITH_NAVIGATION = {
  hasMinimalisticHeader: true,
  hasNavigation: true,
  hasProgressBar: true,
}

export const ES_IMAGES_COHORTS = [
  Cohort.LUVLY_REF,
  Cohort.LUVLY_REF03,
  Cohort.LUVLY_REF4,
  Cohort.QUIZ_2,
]

export const enum GiftCardType {
  GREEN = 'green',
  LIGHT_PINK = 'light_pink',
  YELLOW = 'yellow',
}

export const GIFT_CARDS = {
  [GiftCardType.GREEN]:
    'https://cdn-prod-unified-content.gismart.xyz/34486912bbc40fd28752c59e42098ae09101436d76566d91d767d95811286b02/gift-cards/giftcard-green.png',
  [GiftCardType.LIGHT_PINK]:
    'https://cdn-prod-unified-content.gismart.xyz/34486912bbc40fd28752c59e42098ae09101436d76566d91d767d95811286b02/gift-cards/giftcard-light-pink.png',
  [GiftCardType.YELLOW]:
    'https://cdn-prod-unified-content.gismart.xyz/34486912bbc40fd28752c59e42098ae09101436d76566d91d767d95811286b02/gift-cards/giftcard-yellow.png',
}

export const LUVLY_ONE_LINK = 'https://luvly.onelink.me/Mqac/u3hipgfp'

export const enum ABCDTestVariants {
  VARIANT_A = 'variant_a',
  VARIANT_B = 'variant_b',
  VARIANT_C = 'variant_c',
  VARIANT_D = 'variant_d',
}

export const GROWTHBOOK_EXPERIMENT = {
  LV_27: 'lv_27_primer_integration',
  LV_1113: 'lv_1113_chin_page_set_test',
  LV_804: 'lv_804_primer_form_all_cohorts_test',
  LV_1274: 'lv_1274_coaching_upsell_test',
  LV_1327: 'lv_1327_coaching_upsell_content_test',
  LV_1326: 'lv_1326_sold_out_test',
  LV_1325: 'lv_1325_ref_high_prices_test',
  LV_1338: 'lv_1338_ref4_special_cancel_offer_test',
  LV_1335: 'lv_1335_new_1_screen_intro_fast',
  LV_1361: 'lv_1361_intro_fast_new_paywall_test',
  LV_1337: 'lv_1337_printable_free_book_test',
  LV_1417: 'abtest_wspl_73_mx_br_stripe',
  LV_1410: 'lv_1410_higher_intro_ref4_test',
  LV_1468: 'lv_1468_disclaimer_cancel_test',
  LV_1464: 'lv_1464_first_screen_aref_test',
  LV_1415: 'lv_1415_email_popups_test',
  LV_1493: 'lv_1497_funnellab_cohort_test',
  LV_1530: 'lv_1530_luvly_ref_new_pricing_test',
  LV_1529: 'lv_1529_luvly_ref6_new_pricing_test',
  LV_1539: 'lv_1539_luvly_ref4_first_screen_test',
  LV_1642: 'lv_1642_luvly_ref03_ar_visuals_test',
  LV_1528: 'lv_1528_luvly_ref03_new_pricing_test',
  LV_1618: 'lv_1618_aref_dynamic_headers_test',
  LV_1677: 'lv_1677_black_friday_test',
  LV_1690: 'lv_1690_ref03_age_pages_test',
  LV_1656: 'lv_1656_intro4_sale_high_prices_test',
  LV_1725: 'lv_1725_christmas_test',
}

export const GROWTHBOOK_MX_STRIPE_TEST_VALUES = {
  'Gismart - MX': {
    variantId: 'A',
    variantName: 'abtest_wspl_73_a_mx_br_stripe',
  },
  facetory5: {
    variantId: 'B',
    variantName: 'abtest_wspl_73_b_mx_br_stripe',
  },
  facetory6: {
    variantId: 'C',
    variantName: 'abtest_wspl_73_c_mx_br_stripe',
  },
}

export const COHORT_TO_TEST_MAP: Partial<Record<Cohort, string>> = {
  [Cohort.LUVLY_CHIN]: GROWTHBOOK_EXPERIMENT.LV_1113,
  [Cohort.LUVLY_INTRO_FAST]: GROWTHBOOK_EXPERIMENT.LV_1335,
  [Cohort.LUVLY_REF]: GROWTHBOOK_EXPERIMENT.LV_1493,
}
